import { render, staticRenderFns } from "./LivePlayer.vue?vue&type=template&id=ffaf1f88&"
import script from "./LivePlayer.vue?vue&type=script&lang=js&"
export * from "./LivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./LivePlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports